import { useSearchSuggestionsStartTimingForQuery } from "@faire/retailer-visitor-shared/features/SearchSuggestions-v2/DataFetching/__internal__/useSearchSuggestionsStartTimingForQuery";
import { useSearchSuggestionsQuery } from "@faire/retailer-visitor-shared/features/SearchSuggestions-v2/DataFetching/useSearchSuggestionsQuery";
import { ISearchSuggestionResponse } from "@faire/web-api--source/indigofair/data/ISearchSuggestionResponse";
export var useSearchSuggestionsData = function() {
    var data = useSearchSuggestionsQuery().data;
    var query = data === null || data === void 0 ? void 0 : data.query;
    var startTimingMarker = useSearchSuggestionsStartTimingForQuery(query);
    return {
        searchSuggestionResponse: ISearchSuggestionResponse.build(data),
        startTimingMarker: startTimingMarker,
        query: query
    };
};
